import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Topbar from "./components/Topbar";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Popup from "./components/Popup";
import WebinarFormPopup from "./components/WebinarFormPopup";
import Careers from './pages/Careers'

// Pages
import Home from "./pages/home";
import AboutNewzeal from "./pages/AboutNewzeal";
import Course from "./pages/Course";
import Offers from "./pages/Offers";
import Contact from "./pages/Contact";
import Webinar from "./pages/Webinar";
import Enroll from "./pages/Enroll";
import Terms from "./pages/TermsPage";
import ScrollToTopButton from './ScrollToTopButton';
import TermsPage from "./pages/TermsConditions";
import RefundPolicy from './pages/Refund';
import Privacy from './pages/Privacy';

function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = (content) => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <Router>
      {/* Top information bar */}
      <Topbar />
      {/* Main navigation header */}
      <Header openPopup={openPopup} />

      {/* Page Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutNewzeal />} />
        <Route path="/course" element={<Course />} />
        <Route path="/course/Beginner" element={<Course />} />
        <Route path="/course/Intermediate" element={<Course />} />
        <Route path="/course/Advanced" element={<Course />} />
        <Route path="/career" element={<Careers />} />
        <Route path="/register-for-webinar" element={<Webinar />} />
         <Route path="/enroll-for-course" element={<Enroll />} />
        <Route path="/contact" element={<Contact />} />
         <Route path="/terms-and-conditions" element={<TermsPage />} />
          <Route path="/privacy-policy" element={<Privacy />} />
           <Route path="/refund-policy" element={<RefundPolicy />} />
      </Routes>

      {/* Footer */}
      <Footer />

      {/* Popup */}
      <Popup isOpen={isPopupOpen} onClose={closePopup}>
        <WebinarFormPopup onClose={closePopup} />
      </Popup>

      <ScrollToTopButton/>
    </Router>
  );
}

export default App;
